import { maybeGetGlobal } from '../globals';
export function consentPolicy() {
    return tryResolveNativeAPI() || tryResolveJsSDK() || none();
}
function tryResolveJsSDK() {
    var globalObj = maybeGetGlobal();
    if (globalObj &&
        globalObj.Wix &&
        globalObj.Wix.Utils &&
        typeof globalObj.Wix.Utils._getConsentPolicyHeader === 'function') {
        return globalObj.Wix.Utils._getConsentPolicyHeader();
    }
    return undefined;
}
function tryResolveNativeAPI() {
    var globalObj = maybeGetGlobal();
    if (globalObj &&
        globalObj.consentPolicyManager &&
        typeof globalObj.consentPolicyManager._getConsentPolicyHeader === 'function') {
        return globalObj.consentPolicyManager._getConsentPolicyHeader();
    }
    return undefined;
}
function none() {
    return {};
}
//# sourceMappingURL=consent-policy.js.map